import React, { useState } from 'react';
import './SetupProcess.css';
import { getDemoUser } from '../services/DemoUser';

const SetupProcess = ({ onSetupComplete }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    apiKey: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleNext = () => {
    if (step < 3) {
      setStep(step + 1);
    } else {
      onSetupComplete(formData);
    }
  };

  const handleDemoLogin = () => {
    const password = window.prompt('Enter the demo access password:');
    if (password === 'csjobs') {
      const demoUser = getDemoUser();
      onSetupComplete(demoUser);
    } else if (password !== null) { // User didn't cancel
      alert('Incorrect password. Access denied.');
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const isStepValid = () => {
    switch (step) {
      case 1:
        return formData.name && formData.email && formData.phone;
      case 2:
        return formData.apiKey;
      case 3:
        return true;
      default:
        return false;
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div className="step">
            <h2>Personal Information</h2>
            <p>We need your information to identify ourselves when calling on your behalf.</p>
            <div className="form-group">
              <label htmlFor="name">Full Name*</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter your full name"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address*</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number*</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Enter your phone number"
                required
              />
            </div>
          </div>
        );
      case 2:
        return (
          <div className="step">
            <h2>Google AI Studio API Key</h2>
            <p>Enter your Google AI Studio API key to enable AI-powered calling.</p>
            <div className="form-group">
              <label htmlFor="apiKey">API Key*</label>
              <input
                type="password"
                id="apiKey"
                name="apiKey"
                value={formData.apiKey}
                onChange={handleInputChange}
                placeholder="Enter your Google AI Studio API key"
                required
              />
            </div>
            <div className="info-box">
              <h4>How to get your API key:</h4>
              <ol>
                <li>Go to <a href="https://aistudio.google.com/" target="_blank" rel="noopener noreferrer">Google AI Studio</a></li>
                <li>Sign in with your Google account</li>
                <li>Navigate to "Get API Key" in the left sidebar</li>
                <li>Copy your API key and paste it above</li>
              </ol>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="step">
            <h2>Setup Complete!</h2>
            <p>Your Delegate AI assistant is ready to make calls on your behalf.</p>
            <div className="summary">
              <h4>Summary:</h4>
              <p><strong>Name:</strong> {formData.name}</p>
              <p><strong>Email:</strong> {formData.email}</p>
              <p><strong>Phone:</strong> {formData.phone}</p>
              <p><strong>API Key:</strong> Configured ✓</p>
            </div>
            <div className="disclaimer">
              <h4>Important Notes:</h4>
              <ul>
                <li>All calls will begin with: "This is an AI voice call on behalf of {formData.name}. To stop transcriptions from being recorded, please press 1"</li>
                <li>We identify as your authorized assistant, never impersonating you directly</li>
                <li>All calls are recorded and transcribed for your records</li>
                <li>We comply with TCPA regulations and recording consent laws</li>
              </ul>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="setup-process">
      {/* Demo Login Section */}
      <div className="demo-login-section">
        <h3>Quick Demo Access</h3>
        <p>Want to skip setup and try the platform immediately?</p>
        <button 
          type="button" 
          className="btn btn-demo"
          onClick={handleDemoLogin}
        >
          🚀 Login as Demo User (Password Required)
        </button>
        <div className="demo-details">
          <small>Pre-loaded with demo data and API key for authorized testing</small>
        </div>
      </div>

      <div className="divider">
        <span>or complete setup manually</span>
      </div>

      <div className="progress-bar">
        <div className="progress" style={{ width: `${(step / 3) * 100}%` }}></div>
      </div>
      <div className="step-indicator">
        Step {step} of 3
      </div>
      {renderStep()}
      <div className="buttons">
        {step > 1 && (
          <button type="button" className="btn btn-secondary" onClick={handleBack}>
            Back
          </button>
        )}
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleNext}
          disabled={!isStepValid()}
        >
          {step === 3 ? 'Get Started' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default SetupProcess;